var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurlyPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 41.6483,
    width: 42,
    height: 42,
    transform: "rotate(-82.5803 0 41.6483)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1006_422",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1006_422",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEL0lEQVR4nO2ZWYgcVRSGr3GPS1AUV0RRMC7gBqIPMb6oA9MzU/+53hg0OgoaHyTqm6BI44tGH1zehICgqLigPuiTgqBJRHSCIgmaqGBMFAzEGHUyfU6PXjnVpzqtMnZVdU0mJf1Bw8BUnVv/Xc52nRsyZEhuGNgoRLHMj4nWu5LERmMxAyuF6HkBtjDwCwOzTPSTEE0x0ZOSJFfkNlhWRCoE+LCwgBCOFaImE/2caxzgrRjCicWEAF/HRuMkN0+0iW4QYHvPin4kRPex95fFEJbEEA7V8cX7ZUy0VlfJnt3aV0yPkCmb5Y1xcvKoqkUI8CADf5iAT/Rj+70zPT5+uhBtsu97M5eQCJzWnS3glejcIVUIUDvpfu9Mkgp5SGc+7/vTwJlMtMfev7yvEP2bgYsZ2GsvPVaFEAEeNnuzLeDGMjYYeNxW8qlcQpQ2cB0DYoPfWfL7M1ujTPRn+vN+sqwdIbom25K5hSgqwIRI2/vrywyuh5OJfrSt+kAZGxmpA+h8zy5XRIiiW8te3qtbbk4Dc9t9MXPRsdlc5AYghnCE2eLCQvSQCvCqzeh2dQZ5B2bvL7ItNT0TwnluQGZCOMe+47vCQhR1wwxsyNyz+vo8Awvwgs3g064CGLjDzsi7pYR09yewzT5sg0bmfr5fzxYTtWcmJs52FcDAx+n4SXJXaSHKvhDO0mU1Me/HEI6e0x5wt9l83VUAE91qq/FrHBk5fiAhykySnCvAzm70Hxs7ZY6B37ZnbqvibDCw287Hvf/5cF4hSotoqRB9nzkABi7p/b9GbD3getBjCKcOImI6hDME+La7pft5Pk3Fi2Sx6QBEn9sAvzFwy9+2YEfktkFESJJcmYnQFD+GcLKbD+KqVccI0XM9Wew7rRDOb3t/bXaOStltNBZrSpNlFgJ8WcTtl4a9XyFEP2S5VLZSGgyL2Ikdz6gCdvVk4+v6echKiePjxzHwaJZsmqjdArycejDgKnXDOttx+fLD4ujoCa0QLmwnSUOTQQY+zdJ7W4WvWkRjB0zAvwSFsKR3uxWsNGcZeI+BUCTFnzd0lm1WNwtwj0V4LYx2MLBPg6SVuFs1Smudwt6vyFXKHkh4YuJSE7LT1ZnYyc3E4sjBNctFyWr/FlHi6gwDT1hsedbVGUmSqzMXrAWRqyux2VwkRN+YmJWuzghwv8WIz6pqKy0IWjdk6QYT3ezqjABrbFV25C2RD0ri6tWHd9udwEuuzrB2LolaJmaNqzNMdHu3ZZok5OoM72/2afpyk/tfiKG0cbd20O7jgpJe6uy/I1lfRRdywbDKsBNjgN8ZeESrTFdHtCcmRK/1NC/2aLLZSpILXB1J7wqBD/5xj7mZiZ7RPE1vqLQxEUdGjnR1QLSPRbSuz03vpto4iKj3IN4vs+u6N4ToCy0HLKhO1UbIkCFDXKX8BePUBYNPgcp/AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurlyPlane);
export default __webpack_public_path__ + "static/media/curlyPlane.d9b43f69adf2caf2b0e436e3fda1d08e.svg";
export { ForwardRef as ReactComponent };